interface ChatAudioPlaybackHandle {
  readonly id: string;
  pause: () => void;
}

let active: ChatAudioPlaybackHandle | null = null;

/** Ensures only one chat voice note plays at a time. */
export function beginChatAudioPlayback(handle: ChatAudioPlaybackHandle): void {
  if (active !== null && active.id !== handle.id) {
    active.pause();
  }
  active = handle;
}

export function endChatAudioPlayback(handle: ChatAudioPlaybackHandle): void {
  if (active?.id === handle.id) {
    active = null;
  }
}

export function stopActiveChatAudioPlayback(): void {
  if (active === null) return;
  active.pause();
  active = null;
}
